import { gql } from '@apollo/client';

export const COPY_PICKUP_APPOINTMENTS = gql`
  mutation CopyPickupAppointments($appointmentIds: [Long!]!, $targetDates: [String!]!) {
    copyPickupAppointments(appointmentIds: $appointmentIds, targetDates: $targetDates) {
      appointmentNumber
      successCount
      failureCount
      failureReasons
    }
  }
`;

export interface CopyPickupAppointmentsInput {
  appointmentIds: number[];
  targetDates: string[];
}

export interface CopyPickupAppointmentsResult {
  appointmentNumber: string;
  successCount: number;
  failureCount: number;
  failureReasons: string[];
}

export interface CopyPickupAppointmentsResponse {
  copyPickupAppointments: CopyPickupAppointmentsResult[];
} 